/**
 * DashboardDefaultEditor — ekran ustawiania DOMYŚLNEGO pulpitu tenanta (admin-only, Faza 23 Etap 2).
 *
 * Reuse wspólnego `<DashboardEditor>`: startuje z bieżącego domyślnego układu tenanta (albo z
 * wbudowanego `buildDefaultLayout`, gdy admin jeszcze żadnego nie ustawił), zapis idzie do singletona
 * tenanta przez admin PUT (`useDashboardDefault` → `/dashboard/default-layout`). Wejście przez
 * link-kartę „Domyślny pulpit" w Ustawieniach (bramka `crm_core.dashboard.manage_default`).
 *
 * To NIE jest pulpit osobisty — tu admin edytuje układ, który zobaczą userzy BEZ własnego zapisanego
 * układu (adopt-and-customize: kliknięcie „Zapisz" na WŁASNYM pulpicie tworzy osobistą kopię).
 */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardEditor } from '@/components/dashboard/DashboardEditor';
import { buildDefaultLayout } from '@/components/dashboard/default-layout';
import { useDashboardDefault } from '@/components/dashboard/useDashboardDefault';
import { Spinner } from '@/components/Spinner';

export function DashboardDefaultEditor() {
  const { t } = useTranslation();
  const { layout: remoteLayout, isLoading, saveDefault, isSaving } = useDashboardDefault();

  const builtin = useMemo(() => buildDefaultLayout(t), [t]);
  const baseLayout = remoteLayout ?? builtin;

  if (isLoading) {
    return (
      <main className="min-h-full bg-bg-secondary p-6">
        <div className="mx-auto flex max-w-5xl items-center justify-center py-20">
          <Spinner />
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-full bg-bg-secondary p-6" data-testid="dashboard-default-editor">
      <DashboardEditor
        baseLayout={baseLayout}
        onSave={(next) => saveDefault(next)}
        isSaving={isSaving}
        headerContent={
          <div>
            <h1 className="text-2xl font-bold text-text-primary">
              {t('tenant.dashboardDefault.title')}
            </h1>
            <p className="mt-1 text-sm text-text-tertiary">
              {t('tenant.dashboardDefault.subtitle')}
            </p>
          </div>
        }
      />
    </main>
  );
}
